export default {
  async all(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/admin/permissions`,
      headers: this.headers,
      ...config,
    });
  },
};
